// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './print.css'

class Regulation extends Component {
  constructor (props) {
    super(props)
    this.listRegulations = this.listRegulations.bind(this)
    if (!this.props.regulations || this.props.regulations.length <= 0) { this.listRegulations() }
  }

  listRegulations () {
    if (this.props.vendorId !== undefined) {
      if (this.props.regulationType !== undefined) {
        this.props.listRegulationsVendorAndRegulationType(
          this.props.campaignId,
          this.props.catalogId,
          this.props.vendorId,
          this.props.regulationType
        )
      } else {
        this.props.listRegulationsVendor(
          this.props.campaignId,
          this.props.catalogId,
          this.props.vendorId
        )
      }
    } else {
      this.props.listRegulationsCampaign(
        this.props.campaignId,
        this.props.catalogId
      )
    }
  }

  componentDidUpdate (prevProps) {
    if (
      (this.props.campaignId !== prevProps.campaignId ||
        this.props.catalogId !== prevProps.catalogId ||
        this.props.vendorId !== prevProps.vendorId ||
        this.props.regulationType !== prevProps.regulationType) &&
      (!this.props.regulations || this.props.regulations.length <= 0)
    ) {
      this.listRegulations()
    }
  }

  componentDidMount () {
    const termContainer = document.querySelector('#term-container li')
    const termLink = document.querySelector('#term-container a')
    termContainer && (
      termContainer.classList.add('color-ui-1')
    )

    termLink && (
      termLink.classList.add('color-brand-1')
    )
  }

  render () {
    return (
      <div className={this.props.vendorId ? '' : 'divPrint'} role='article'>
        {this.props.regulations &&
          this.props.regulations.map(regulation => (
            <div id='term-container' dangerouslySetInnerHTML={{ __html: regulation }} />
          ))}
      </div>
    )
  }
}

Regulation.propTypes = {
  regulations: PropTypes.array,
  campaignId: PropTypes.number,
  catalogId: PropTypes.number,
  listRegulationsVendor: PropTypes.func,
  listRegulationsCampaign: PropTypes.func,
  listRegulationsVendorAndRegulationType: PropTypes.func,
  vendorId: PropTypes.number,
  regulationType: PropTypes.number
}

export default Regulation



// WEBPACK FOOTER //
// ./src/features/Regulation/Regulation.js